import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from 'lp-components';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button } from 'shared';
import { selectors } from '../reducer';
function PrequalDeclineModal({ onContinue, practice, }) {
    return (_jsx(Modal, { hideCloseButton: true, onClose: onContinue, overlayClassName: "modal-fade-screen prequal-decline-modal-overlay", className: "modal-inner prequal-decline-modal modal", children: _jsx("div", { children: _jsxs("div", { className: "prequal-decline-modal__container", children: [_jsxs("div", { className: "details", children: ["We were unable to pre-qualify you for an Alphaeon Credit Card.", _jsx("br", {}), _jsx("br", {}), "However, you have been pre-qualified for our Access Loan", practice && ` at ${practice.name}`, "."] }), _jsx("div", { className: "button-block", children: _jsx(Button, { className: "button-warn-outline", onClick: onContinue, type: "button", children: "Continue" }) })] }) }) }));
}
function mapStateToProps(state) {
    return {
        practice: selectors.practice(state),
    };
}
const mapDispatchToProps = {};
export default compose(connect(mapStateToProps, mapDispatchToProps))(PrequalDeclineModal);
